import React from "react";
import Headline from "./Headline";
import ContactAgents from "../../components/shared/ContactAgents";
import HomeLink from "../../widgets/HomeLink";

const bannerPath = '/iceholidays-assets/images/gd_flight_cover_latest.png';
const breadcrumbs = [
  { title: <HomeLink/>},
  { title: 'GD Flight Contact Agents' }
] 

class GDFlightContactAgentsPage extends React.Component {

  componentDidMount(): void {
    
  }
  

  render(){
    return (
      <div id="contact-agents-page" className="more-page">
        <Headline showSearch={false} bannerImage={bannerPath} breadcrumbs={breadcrumbs}>
          <span className="title">
            About
            <img src="/iceholidays-assets/images/gd_flight_icon.png" alt="GD Flight Logo" />
          </span>
        </Headline>

        <ContactAgents type="Flight"/>
      </div>
    )
  }
}

export default GDFlightContactAgentsPage;